

const Allroles = {
  "frontend developer": { 
    requiredSkills: [
      "html", "css", "javascript", "react", "angular", "vue.js", "typescript", "git",
    ],
    relevantTitles: [
      "frontend developer",
      "front-end developer",
      "web developer",
      "ui developer",
      "front-end engineer",
      "javascript developer",
    ],
    certificateKeywords: [
      "frontend", "web dev", "javascript", "react", "css", "html", "ui/ux",
    ],
    relevantDegrees: [
      "bca", "b.sc. it", "btech", "mtech", "m.sc. it", "p.d.d. web and mobile app development and design"
    ]
  },
  "backend developer": {
    requiredSkills: [
      "node.js", "express", "mongodb", "sql", "java", "python", "api", "rest", "graphql", "docker", "git",
    ],
    relevantTitles: [
      "backend developer",
      "back-end developer", 
      "api developer",
      "software engineer (backend)",
      "java developer",
      "python developer",
    ],
    relevantDegrees: [
      "bca", "b.sc. it", "btech", "mtech", "m.sc. it", "p.d.d. web and mobile app development and design"
    ],
    certificateKeywords: [
      "backend", "api", "node", "server", "database", "express", "cloud", "aws", "azure", "gcp",
    ],
  },
  "fullstack developer": { 
    requiredSkills: [
      "html", "css", "javascript", "react", "node.js", "express", "mongodb", "git", "api",
    ],
    relevantTitles: [
      "fullstack developer",
      "full stack developer",   
      "full-stack developer",   
      "software engineer (fullstack)",
      "web developer (fullstack)",
    ],
    relevantDegrees: [
      "bca", "b.sc. it", "btech", "mtech", "m.sc. it", "p.d.d. web and mobile app development and design"
    ],
    certificateKeywords: [
      "fullstack", "web dev", "javascript", "backend", "frontend", "api", "node", "react",
    ],
  },
  "ux designer": {
    requiredSkills: [
      "user research", "wireframing", "prototyping", "usability testing", "figma", "sketch", "adobe xd", "information architecture",
    ],
    relevantTitles: [
      "ux designer",
      "user experience designer",
      "ux specialist",
      "product designer (ux focus)",
      "human factors engineer",
    ],
    relevantDegrees: [
      "human-computer interaction", "h.c.i.", "cognitive psychology", "interaction design", "ux design",
    ],
    certificateKeywords: [
      "ux design", "user experience", "usability", "design thinking", "human centered design",
    ],
  },
  "ui designer": {
    requiredSkills: [
      "figma", "sketch", "adobe xd", "photoshop", "illustrator", "visual design", "design systems", "typography", "color theory",
    ],
    relevantTitles: [
      "ui designer",
      "user interface designer",
      "visual designer",
      "graphic designer (ui focus)",
      "product designer (ui focus)",
    ],
    relevantDegrees: [
      "graphic design", "visual communication", "fine arts", "web design",
    ],
    certificateKeywords: [
      "ui design", "user interface", "visual design", "design tools", "graphic design",
    ],
  },
};

export default Allroles;